import React, { useEffect, useState } from "react";

function CursorLine() {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // 1. Inject global CSS to hide the cursor on ALL elements (including hover states)
    const style = document.createElement("style");
    style.innerHTML = `* { cursor: none !important; }`;
    document.head.appendChild(style);

    const handleMouseMove = (e) => {
      // Use requestAnimationFrame for smoother performance on high-refresh monitors
      requestAnimationFrame(() => {
        setPosition({ x: e.clientX, y: e.clientY });
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      // 2. Clean up: Restore the cursor when the component unmounts
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "20px",
        height: "20px",
        backgroundColor: "black",
        borderRadius: "50%",
        pointerEvents: "none", // Ensures you can still click things "under" the custom cursor
        zIndex: 9999,
        // Use translate3d to trigger Hardware Acceleration for better performance
        transform: `translate3d(${position.x - 10}px, ${position.y - 10}px, 0)`,
        transition: "transform 0.1s ease-out",
      }}
    />
  );
}

export default CursorLine;







// import React, { useEffect, useRef } from "react";

// function CursorLine() {
//   const canvasRef = useRef(null);
//   const points = useRef([]);
//   const mouse = useRef({ x: 0, y: 0 });
//   const smoothMouse = useRef({ x: 0, y: 0 });

//   const MAX_POINTS = 40;
//   const CURSOR_RADIUS = 12;
//   const BORDER_WIDTH = 2;

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");

//     // Hide default cursor
//     const style = document.createElement("style");
//     style.innerHTML = `* { cursor: none !important; }`;
//     document.head.appendChild(style);

//     const resize = () => {
//       canvas.width = window.innerWidth;
//       canvas.height = window.innerHeight;
//     };

//     const onMouseMove = (e) => {
//       mouse.current.x = e.clientX;
//       mouse.current.y = e.clientY;
//     };

//     const animate = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Smooth mouse movement
//       smoothMouse.current.x +=
//         (mouse.current.x - smoothMouse.current.x) * 0.2;
//       smoothMouse.current.y +=
//         (mouse.current.y - smoothMouse.current.y) * 0.2;

//       points.current.push({ ...smoothMouse.current });
//       if (points.current.length > MAX_POINTS) points.current.shift();

//       // ---- TRAIL ----
//       if (points.current.length > 2) {
//         const head = points.current[points.current.length - 1];
//         const tail = points.current[0];

//         const gradient = ctx.createLinearGradient(
//           tail.x,
//           tail.y,
//           head.x,
//           head.y
//         );
//         gradient.addColorStop(0, "rgba(255,105,41,0)");
//         gradient.addColorStop(1, "rgba(255,105,41,0.6)");

//         ctx.beginPath();
//         ctx.lineCap = "round";
//         ctx.lineJoin = "round";
//         ctx.strokeStyle = gradient;
//         ctx.lineWidth = 5;

//         ctx.moveTo(tail.x, tail.y);

//         for (let i = 1; i < points.current.length - 1; i++) {
//           const p1 = points.current[i];
//           const p2 = points.current[i + 1];
//           ctx.quadraticCurveTo(
//             p1.x,
//             p1.y,
//             (p1.x + p2.x) / 2,
//             (p1.y + p2.y) / 2
//           );
//         }

//         ctx.stroke();
//       }

//       // ---- TRANSPARENT CIRCLE CURSOR ----
//       ctx.beginPath();
//       ctx.arc(
//         smoothMouse.current.x,
//         smoothMouse.current.y,
//         CURSOR_RADIUS,
//         0,
//         Math.PI * 2
//       );

//       ctx.lineWidth = BORDER_WIDTH;
//       ctx.strokeStyle = "rgba(255,105,41,1)";
//       ctx.stroke();

//       requestAnimationFrame(animate);
//     };

//     window.addEventListener("mousemove", onMouseMove);
//     window.addEventListener("resize", resize);

//     resize();
//     animate();

//     return () => {
//       document.head.removeChild(style);
//       window.removeEventListener("mousemove", onMouseMove);
//       window.removeEventListener("resize", resize);
//     };
//   }, []);

//   return (
//     <canvas
//       ref={canvasRef}
//       style={{
//         position: "fixed",
//         inset: 0,
//         pointerEvents: "none",
//         zIndex: 99999,
//       }}
//     />
//   );
// }

// export default CursorLine;
